var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSeen = function SvgSeen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.318 5.004C13.536 6.077 14.473 7.308 14.955 8c-.482.692-1.419 1.923-2.637 2.996C11.008 12.15 9.513 13 8 13c-1.513 0-3.009-.85-4.318-2.004C2.464 9.923 1.527 8.692 1.045 8c.482-.692 1.419-1.923 2.637-2.996C4.992 3.85 6.487 3 8 3c1.513 0 3.009.85 4.318 2.004ZM8 14c3.75 0 6.908-4.159 7.86-5.552a.792.792 0 0 0 0-.897C14.909 6.16 11.75 2 8 2S1.092 6.159.14 7.551a.792.792 0 0 0 0 .897C1.091 9.841 4.25 14 8 14Zm2-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgSeen;